import { FretBoardV2 } from "../../../Comps/FretBoard/FretBoardV2";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";

export function FretBoardChapter(){
    return(
        <div className={'fret-board-chapter'}>
            <h1>The Fretboard</h1>
            <OutlineBox>
                <FretBoardV2/>
            </OutlineBox>
        </div>

    )
}